var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer",on:{"click":function($event){_vm.$route.query.back ? _vm.$router.push(_vm.$route.query.back) : _vm.$router.go(-1)}}},[_c('i-back')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }